import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-60e2219d")

_pushScopeId("data-v-60e2219d")
const _hoisted_1 = { class: "pay-info-container" }
const _hoisted_2 = {
  key: 0,
  class: "padding5px"
}
const _hoisted_3 = { class: "label-title" }
const _hoisted_4 = { class: "label-content" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
const _hoisted_6 = { class: "second-title" }
const _hoisted_7 = { class: "padding5px" }
const _hoisted_8 = { class: "label-title" }
const _hoisted_9 = { class: "label-content" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
const _hoisted_11 = { class: "second-title" }
const _hoisted_12 = { class: "padding5px" }
const _hoisted_13 = { class: "label-title" }
const _hoisted_14 = { class: "label-content" }
const _hoisted_15 = { class: "padding5px" }
const _hoisted_16 = { class: "label-title" }
const _hoisted_17 = { class: "label-content" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_cus_button = _resolveComponent("cus-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.info, (item) => {
      return (_openBlock(), _createBlock(_Fragment, { key: item }, [
        (!(item.show===false))
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode("label", _hoisted_3, _toDisplayString(item.label), 1),
              _createVNode("label", _hoisted_4, _toDisplayString(item.content), 1)
            ]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128)),
    (_ctx.orderDetail.StatusEnum === '1')
      ? (_openBlock(), _createBlock(_component_cus_button, {
          key: 0,
          onClick: _ctx.invoice,
          type: "blue",
          class: "downLoad"
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextDownReceiptFile), 1)
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true),
    _hoisted_5,
    (_ctx.showPaypalOrderInfo(_ctx.orderDetail.StatusEnum))
      ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          _createVNode("div", _hoisted_6, _toDisplayString(_ctx.platformInfoText), 1),
          _createVNode("div", _hoisted_7, [
            _createVNode("label", _hoisted_8, _toDisplayString(_ctx.platformInfoOrderText), 1),
            _createVNode("label", _hoisted_9, _toDisplayString(_ctx.orderDetail.PaypalOrder), 1)
          ]),
          _hoisted_10
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.orderDetail.CouponNumber !== null)
      ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
          _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$wordList.ProperAllTextCouponInfo), 1),
          _createVNode("div", _hoisted_12, [
            _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$wordList.ProperAllTextCouponNumber), 1),
            _createVNode("label", _hoisted_14, _toDisplayString(_ctx.orderDetail.CouponNumber), 1)
          ]),
          _createVNode("div", _hoisted_15, [
            _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$wordList.ProperAllTextCouponUsageAmount), 1),
            _createVNode("label", _hoisted_17, _toDisplayString(_ctx.orderDetail.CouponCount), 1)
          ]),
          _hoisted_18
        ], 64))
      : _createCommentVNode("", true)
  ]))
})